import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CalendarView } from '../components/calendar/CalendarView';
import { EventDetails } from '../components/events/EventDetails';

import { LoadingSpinner } from '../components/ui/loading-spinner.tsx';
import {
  useCreateEvent,
  useDeleteEvent,
  useGetEvents,
  useUpdateEvent,
} from '../api/events/eventQueries.js';

export default function Events({ view = 'list' }) {
  const { eventId } = useParams();
  const { data: allEvents, error, isLoading } = useGetEvents();
  const { mutate: deleteEvent } = useDeleteEvent();
  const { mutate: updateEvent } = useUpdateEvent();
  const { mutate: createEvent } = useCreateEvent();

  const [selectedType, setSelectedType] = useState('all');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCreateEvent = () => {
    setSelectedEvent(null);
    setIsModalOpen(true);
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const handleSaveEvent = (eventData) => {
    if (selectedEvent) {
      updateEvent({ id: selectedEvent.eventId, data: eventData });
    } else {
      createEvent(eventData);
    }
    setIsModalOpen(false);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh-4rem)]">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto py-6">
        <div className="bg-red-50 text-red-600 p-4 rounded-lg">
          Error loading events: {error.message}
        </div>
      </div>
    );
  }

  // Determine which events to show based on filters
  // const getFilteredEvents = () => {
  //   let filteredEvents = eventRefetch();

  //   if (selectedType !== 'all') {
  //     filteredEvents = getEventsByType(selectedType);
  //   }

  //   return filteredEvents;
  // };

  // Determine which view to show based on the route or prop
  const currentView =
    view === 'calendar' ? 'calendar' : eventId ? 'details' : 'list';

  const renderView = () => {
    switch (currentView) {
      case 'calendar':
        return (
          <CalendarView
            events={allEvents.data}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedEvent={selectedEvent}
            setSelectedEvent={setSelectedEvent}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            onEventClick={handleEventClick}
            onCreateEvent={handleCreateEvent}
            onSaveEvent={handleSaveEvent}
            onDeleteEvent={deleteEvent}
          />
        );
      case 'details':
        const event = allEvents.data.find((e) => {
          console.log('Event page', e);
          const eventUrlId = `${e.eventTitle
            .toLowerCase()
            .replace(/\s+/g, '-')}-${e.eventDate
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')}`;
          return eventUrlId === eventId;
        });
        return <EventDetails event={event} />;
      default:
        return (
          <CalendarView
            events={allEvents.data}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedEvent={selectedEvent}
            setSelectedEvent={setSelectedEvent}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            onEventClick={handleEventClick}
            onCreateEvent={handleCreateEvent}
            onSaveEvent={handleSaveEvent}
            onDeleteEvent={deleteEvent}
          />
        );
    }
  };

  return (
    <div className=" mx-auto py-6 px-5 w-full">
      {currentView !== 'details' && (
        <div className="mb-6 flex items-center gap-4">
          <select
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            className="rounded-lg border border-gray-300 px-3 py-2"
          >
            <option value="all">All Events</option>
            <option value="Events">Events</option>
            <option value="Tasks">Tasks</option>
            <option value="Schedule">Schedule</option>
          </select>
        </div>
      )}

      <div className="">{renderView()}</div>
    </div>
  );
}
